import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PlayCircleOutlined } from '@ant-design/icons';
import { Image, Modal } from 'antd';
import { useMemo, useState } from 'react';
import { createUseStyles } from 'react-jss';
import { VideoPlayer } from '../VideoPlayer';
const useStyles = createUseStyles({
    videBox: {
        margin: '0 8px 8px 0',
        display: 'inline-block',
        verticalAlign: 'top',
        position: 'relative',
        width: '114px',
        height: '72px',
        '& .videoMask': {
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            color: '#ffffff',
            background: 'rgba(0,0,0,.5)',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 18,
            display: 'none',
        },
        '&:hover': {
            '& .videoMask': {
                display: 'flex',
            }
        }
    },
    previewImageGroup: {
        '& .ant-image-preview-switch-left, .ant-image-preview-switch-right': {
            position: 'fixed'
        }
    }
});
const defaultFieldNames = {
    contentType: 'contentType',
    fileSrcUrl: 'fileSrcUrl',
    thumbnailSrcUrl: 'thumbnailSrcUrl',
    id: 'id',
    fileName: 'fileName'
};
// 追加的字段请备注好是什么意思（比如：thumbnailSrcUrl）
export const ImageVideoGroup = ({ fileList, fieldNames = defaultFieldNames }) => {
    const [previewCurrent, setPreviewCurrent] = useState({
        visible: false,
        current: 0
    });
    const [videoConfig, setVideoConfig] = useState({
        visible: false,
        data: { fileName: '', fileSrcUrl: '' }
    });
    const styles = useStyles();
    const imageList = useMemo(() => {
        return fileList?.filter(item => item[fieldNames.contentType || defaultFieldNames.contentType]?.indexOf('video/') === -1) ?? [];
    }, [fileList]);
    return _jsxs("div", { children: [fileList?.map(item => {
                return item[fieldNames.contentType || defaultFieldNames.contentType]?.indexOf('video/') > -1 ?
                    _jsxs("div", { className: styles.videBox, onClick: () => {
                            setVideoConfig({
                                data: item,
                                visible: true
                            });
                        }, children: [_jsx("video", { src: item[fieldNames.fileSrcUrl || defaultFieldNames.fileSrcUrl], controls: true, height: 72, width: 114 }), _jsx("div", { className: "videoMask", children: _jsx(PlayCircleOutlined, {}) })] }, item.id)
                    :
                        _jsx("div", { style: {
                                margin: '0 8px 8px 0',
                                display: 'inline-block',
                                verticalAlign: 'top'
                            }, children: _jsx(Image, { preview: { visible: false }, src: item[fieldNames.thumbnailSrcUrl || defaultFieldNames.thumbnailSrcUrl] || item[fieldNames.fileSrcUrl || defaultFieldNames.fileSrcUrl], height: 72, width: 114, onClick: () => {
                                    const index1 = imageList.findIndex(item1 => item1[fieldNames.id || defaultFieldNames.id] === item[fieldNames.id || defaultFieldNames.id]);
                                    setPreviewCurrent({
                                        visible: true,
                                        current: index1
                                    });
                                } }) });
            }), _jsx("div", { style: { display: 'none' }, children: _jsx(Image.PreviewGroup, { preview: {
                        visible: previewCurrent.visible,
                        current: previewCurrent.current,
                        onVisibleChange: (vis) => setPreviewCurrent({
                            ...previewCurrent,
                            visible: vis
                        }),
                        rootClassName: styles.previewImageGroup
                    }, children: imageList?.map(item => _jsx(Image, { src: item[fieldNames.fileSrcUrl || defaultFieldNames.fileSrcUrl] }, item.id)) }) }), _jsx(Modal, { width: 600, title: videoConfig.data?.[fieldNames.fileName || defaultFieldNames.fileName], visible: videoConfig.visible, onCancel: () => setVideoConfig({
                    ...videoConfig,
                    visible: false,
                }), footer: null, getContainer: () => document.body, bodyStyle: {
                    padding: 0
                }, children: _jsx(VideoPlayer, { style: { height: '500px', width: '100%' }, 
                    // @ts-ignore
                    fluid: false, src: videoConfig.data?.[fieldNames.fileSrcUrl || defaultFieldNames.fileSrcUrl] }) })] });
};
